var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"flex-column",attrs:{"dark":_vm.dark,"color":"footer"}},[(_vm.links.length > 0)?_c('c-nav',{staticClass:"mb-2",attrs:{"links":_vm.links}}):_vm._e(),_c('c-credit')],1)}
var staticRenderFns = []

export { render, staticRenderFns }